export default __webpack_public_path__ + "static/media/timer.f922adeb.svg";